import { render } from "./ViewChannels.vue?vue&type=template&id=3a235490"
import script from "./ViewChannels.vue?vue&type=script&lang=js"
export * from "./ViewChannels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__